import { IonList as IonicIonList } from '@ionic/react'
import { styled } from 'styled-components'

export const IonList = styled(IonicIonList)`
  background: transparent;
  padding: 8px 6px;
  margin: 0 -6px;
`
